import React from "react";
import { Box, LinearProgress } from "@mui/material";

const FullPageLoader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        zIndex: (theme) => theme.zIndex.appBar + 1,
      }}
    >
      <LinearProgress />
    </Box>
  );
};

export default FullPageLoader;
